import type { GenderSwitchElement } from "../../aysa_api/models/gender_switch_element.types";
import { Reader, Writer } from "protobufjs/minimal";
import {
  createBaseCategory,
  encodeCategory,
  decodeCategory,
} from "../../aysa_api/models/category";

export const createBaseGenderSwitchElement = (): GenderSwitchElement => {
  return {
    category: createBaseCategory(),
    label: "",
  };
};

export const decodeGenderSwitchElement = (
  reader: Reader,
  length: number
): GenderSwitchElement => {
  const end = reader.pos + length;
  const message = createBaseGenderSwitchElement();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.category = decodeCategory(reader, reader.uint32());

        break;
      case 2:
        message.label = reader.string();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeGenderSwitchElement = (
  writer: Writer,
  message: GenderSwitchElement
): Writer => {
  encodeCategory(writer.uint32(10).fork(), message.category).ldelim();
  writer.uint32(18).string(message.label);

  return writer;
};
